// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"cfb68edb","72":"22657ca3","151":"7ec23a9d","236":"64ecbf09","239":"5111ac1c","393":"7073c4b2","455":"33c9ad1d","650":"43d61c32","666":"05d3c01e","722":"08292295","757":"ba3df1a8","945":"3a148dad","977":"d79714b3"}[chunkId] + ".chunk.js";
};